module.exports = __webpack_public_path__ + "static/media/spicy_bowl.88479a18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dish_image/spicy_bowl.jpg
// module id = 162
// module chunks = 0